import distinguishedFolderId from 'owa-service/lib/factory/distinguishedFolderId';
import DistinguishedFolderIdName from 'owa-service/lib/contract/DistinguishedFolderIdName';
import serviceUserConfiguration from 'owa-service/lib/factory/serviceUserConfiguration';
import SingleResponseMessage from 'owa-service/lib/contract/SingleResponseMessage';
import updateUserConfigurationOperation from 'owa-service/lib/operation/updateUserConfigurationOperation';
import updateUserConfigurationOwaRequest from 'owa-service/lib/factory/updateUserConfigurationOwaRequest';
import userConfigurationDictionaryEntry from 'owa-service/lib/factory/userConfigurationDictionaryEntry';
import userConfigurationDictionaryObject from 'owa-service/lib/factory/userConfigurationDictionaryObject';
import UserConfigurationDictionaryObject from 'owa-service/lib/contract/UserConfigurationDictionaryObject';
import userConfigurationNameType from 'owa-service/lib/factory/userConfigurationNameType';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import { MailboxInfo, getUserMailboxInfo } from 'owa-client-ids';
import { getDefaultRequestOptions } from 'owa-headers';

export const VIEW_STATE_CONFIGURATION: string = 'OWA.ViewStateConfiguration';
export const USER_OPTIONS_CONFIGURATION: string = 'OWA.UserOptions';

const USER_OPTIONS_BASEFOLDERID_NAME: DistinguishedFolderIdName = 'root';

export async function updateUserConfigurationService(
    userConfigurationName: string,
    key: UserConfigurationDictionaryObject,
    value: UserConfigurationDictionaryObject,
    mailboxInfo?: MailboxInfo
): Promise<SingleResponseMessage> {
    let newUserConfiguration = serviceUserConfiguration({
        UserConfigurationName: userConfigurationNameType({
            Name: userConfigurationName,
            BaseFolderId: distinguishedFolderId({
                Id: USER_OPTIONS_BASEFOLDERID_NAME,
            }),
        }),
        Dictionary: [
            userConfigurationDictionaryEntry({
                DictionaryKey: userConfigurationDictionaryObject(key),
                DictionaryValue: userConfigurationDictionaryObject(value),
            }),
        ],
    });

    if (!mailboxInfo) {
        mailboxInfo = getUserMailboxInfo();
    }

    const response = await updateUserConfigurationOperation(
        {
            Header: getJsonRequestHeader(),
            Body: updateUserConfigurationOwaRequest({
                UserConfiguration: newUserConfiguration,
            }),
        },
        await getDefaultRequestOptions(mailboxInfo)
    );

    return response.Body.ResponseMessages.Items[0];
}
